<template>
  <form-select
    :loading="loading"
    :options="options"
    v-model="val"
    @visible-change="visibleChange"
    filterable
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
export default {
  name: 'form-select-project',
  props: {
    value: [String, Array],
    type: String
  },
  data() {
    return {
      options: [],
      loading: false
    }
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.refreshOptions()
  },
  methods: {
    visibleChange(visible) {
      if (visible && this.options.length == 0) {
        this.refreshOptions()
      }
    },
    refreshOptions() {
      this.loading = true
      var params = {
        PageIndex: 1,
        PageSize: 9999
      }
      if (this.type) {
        params.type = JSON.stringify({
          Field: 'type',
          ComparePattern: 'EQ',
          Values: [this.type]
        })
      }
      this.$post('/project/find', params)
        .then((resp) => {
          this.loading = false
          if (resp.data.code == 0) {
            this.options = (resp.data.data.Data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              }
            })
          } else {
            this.$message(`获取项目选项失败=>${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.loading = false
          console.error('获取项目选项发生异常:', err)
          this.$message(`获取项目选项发生异常=>${err}`)
        })
    }
  }
}
</script>
